/**
 * front-page.js — Synthwave 80s effects
 * Caricato solo sulla front-page tramite wp_enqueue_script.
 * THEME_URI viene letto dall'attributo data-theme-uri sull'elemento #sw-config.
 */
(function () {
  'use strict';

  // ── Fix viewport height su mobile (iOS/Android barra indirizzi) ────────────
  function setVH() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
  }
  setVH();
  window.addEventListener('resize', setVH);
  window.addEventListener('orientationchange', function () {
    setTimeout(setVH, 200);
  });

  // ── Leggi THEME_URI dal DOM (iniettato da PHP) ─────────────────────────────
  var swConfig = document.getElementById('sw-config');
  var THEME_URI = swConfig ? swConfig.dataset.themeUri : '';

  // ── CONFIG ─────────────────────────────────────────────────────────────────
  var CONFIG = {
    CUSTOM_IMAGES: [
      { src: THEME_URI + '/assets/img/img1.png', x: 15, y: 30, size: 160, anim: 'fb', dur: '6s', delay: '-2s', glow: '#ffe600', parX: 0.035, parY: 0.028 },
      { src: THEME_URI + '/assets/img/img2.png', x: 82, y: 60, size: 140, anim: 'fa', dur: '5.5s', delay: '-1s', glow: '#ff2d7a', parX: 0.045, parY: 0.038 },
      { src: THEME_URI + '/assets/img/img3.png', x: 8, y: 68, size: 130, anim: 'fd', dur: '4.5s', delay: '-3s', glow: '#00f5ff', parX: 0.052, parY: 0.042 },
    ],
    DECORATIVE_ELEMENTS: [
      { type: 'pacman', x: 18, y: 22, size: 90, color: '#ffe600', anim: 'fb', dur: '5s', delay: '-1.5s', parX: 0.030, parY: 0.025 },
      { type: 'star', x: 75, y: 75, size: 110, color: '#ff2d7a', anim: 'fa', dur: '6s', delay: '-2s', parX: 0.035, parY: 0.028 },
      { type: 'star', x: 60, y: 30, size: 70, color: '#00f5ff', anim: 'fc', dur: '8s', delay: '-5s', parX: 0.018, parY: 0.015 },
      { type: 'cassette', x: 90, y: 50, size: 130, color: '#bf00ff', anim: 'fb', dur: '6s', delay: '-0.5s', parX: 0.025, parY: 0.032 },
      { type: 'diamond', x: 10, y: 78, size: 95, color: '#ff6b1a', anim: 'fa', dur: '7s', delay: '-3s', parX: 0.022, parY: 0.020 },
      { type: 'triangle', x: 85, y: 35, size: 75, color: '#00f5ff', anim: 'frr', dur: '10s', delay: '-2s', parX: 0.028, parY: 0.018 },
      { type: 'text', text: 'WAVE', x: 5, y: 45, size: '3rem', color: '#ff2d7a', anim: 'fb', dur: '6s', delay: '-1s', parX: 0.015, parY: 0.012 },
      { type: 'text', text: '1984', x: 65, y: 80, size: '2.5rem', color: '#ffe600', anim: 'fd', dur: '5s', delay: '-3s', parX: 0.038, parY: 0.030 },
    ],
    TILT_MAX: 10,
    TILT_SMOOTH: 0.06,
    PAR_SMOOTH: 0.06,
    SUBJECT_BLUR_MAX: 6,
    SUBJECT_BLUR_SMOOTH: 0.04,
    DOF_FOCUS_RADIUS: 250,
    DOF_BLUR_MAX: 8,
  };

  // ── SVG factories ───────────────────────────────────────────────────────────
  function star(size, color) {
    var pts = Array.from({ length: 10 }, function (_, i) {
      var a = (i / 10) * Math.PI * 2 - Math.PI / 2;
      var r = i % 2 === 0 ? size / 2 : size / 4.5;
      return (Math.cos(a) * r + size / 2) + ',' + (Math.sin(a) * r + size / 2);
    }).join(' ');
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 ' + size + ' ' + size + '">' +
      '<polygon points="' + pts + '" fill="' + color + '" style="filter:drop-shadow(0 0 8px ' + color + ')"/>' +
      '</svg>';
  }

  function pacman(size, color) {
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 90 90">' +
      '<path d="M45,45 L87,18 A43,43 0 1,0 87,72 Z" fill="' + color + '" style="filter:drop-shadow(0 0 10px ' + color + ')"/>' +
      '<circle cx="52" cy="26" r="5" fill="#0d0015"/>' +
      '</svg>';
  }

  function cassette(size, color) {
    var h = size * 0.63;
    return '<svg width="' + size + '" height="' + h + '" viewBox="0 0 130 82" fill="none">' +
      '<rect x="3" y="8" width="124" height="66" rx="7" stroke="' + color + '" stroke-width="2.5" style="filter:drop-shadow(0 0 8px ' + color + ')"/>' +
      '<rect x="28" y="18" width="74" height="34" rx="3" stroke="' + color + '" stroke-width="2"/>' +
      '<circle cx="46" cy="35" r="11" stroke="' + color + '" stroke-width="2"/>' +
      '<circle cx="84" cy="35" r="11" stroke="' + color + '" stroke-width="2"/>' +
      '<circle cx="46" cy="35" r="4" fill="' + color + '" opacity="0.7"/>' +
      '<circle cx="84" cy="35" r="4" fill="' + color + '" opacity="0.7"/>' +
      '<path d="M57 41 Q65 46 73 41" stroke="' + color + '" stroke-width="1.5" fill="none"/>' +
      '<circle cx="14" cy="17" r="3.5" fill="' + color + '" opacity="0.5"/>' +
      '<circle cx="116" cy="17" r="3.5" fill="' + color + '" opacity="0.5"/>' +
      '<circle cx="14" cy="65" r="3.5" fill="' + color + '" opacity="0.5"/>' +
      '<circle cx="116" cy="65" r="3.5" fill="' + color + '" opacity="0.5"/>' +
      '</svg>';
  }

  function diamond(size, color) {
    var h = size, w = size * 0.7;
    return '<svg width="' + w + '" height="' + h + '" viewBox="0 0 ' + w + ' ' + h + '" fill="none">' +
      '<polygon points="' + (w / 2) + ',4 ' + (w - 4) + ',' + (h / 2) + ' ' + (w / 2) + ',' + (h - 4) + ' 4,' + (h / 2) + '"' +
      ' stroke="' + color + '" stroke-width="2.5" fill="' + color + '" fill-opacity="0.15"' +
      ' style="filter:drop-shadow(0 0 10px ' + color + ')"/>' +
      '</svg>';
  }

  function triangle(size, color) {
    var h = size * 0.87;
    return '<svg width="' + size + '" height="' + h + '" viewBox="0 0 ' + size + ' ' + h + '" fill="none">' +
      '<polygon points="' + (size / 2) + ',3 ' + (size - 3) + ',' + (h - 3) + ' 3,' + (h - 3) + '"' +
      ' stroke="' + color + '" stroke-width="2.5" fill="' + color + '" fill-opacity="0.12"' +
      ' style="filter:drop-shadow(0 0 10px ' + color + ')"/>' +
      '</svg>';
  }

  function wordEl(text, color, size) {
    return '<div style="font-family:\'Orbitron\',monospace;font-weight:900;font-size:' + size + ';' +
      'color:transparent;-webkit-text-stroke:2px ' + color + ';' +
      'text-shadow:0 0 20px ' + color + ',0 0 40px ' + color + ';' +
      'letter-spacing:0.1em;white-space:nowrap;line-height:1;">' + text + '</div>';
  }

  // ── Build floaters ──────────────────────────────────────────────────────────
  var tiltEl = document.getElementById('tilt');
  if (!tiltEl) return;

  var floaterEls = [];

  CONFIG.CUSTOM_IMAGES.forEach(function (cfg) {
    var div = document.createElement('div');
    div.className = 'floater ' + cfg.anim;
    div.style.cssText = 'left:' + cfg.x + '%;top:' + cfg.y + '%;--d:' + cfg.dur + ';--dl:' + cfg.delay + ';transform:translate(-50%,-50%);';
    var img = document.createElement('img');
    img.src = cfg.src;
    img.width = cfg.size;
    img.draggable = false;
    if (cfg.glow) img.style.filter = 'drop-shadow(0 0 10px ' + cfg.glow + ') drop-shadow(0 0 25px ' + cfg.glow + ')';
    img.onerror = function () { div.style.display = 'none'; };
    div.appendChild(img);
    tiltEl.appendChild(div);
    floaterEls.push({ el: div, parX: cfg.parX, parY: cfg.parY, posX: cfg.x, posY: cfg.y });
  });

  CONFIG.DECORATIVE_ELEMENTS.forEach(function (cfg) {
    var div = document.createElement('div');
    div.className = 'floater ' + cfg.anim;
    div.style.cssText = 'left:' + cfg.x + '%;top:' + cfg.y + '%;--d:' + cfg.dur + ';--dl:' + cfg.delay + ';transform:translate(-50%,-50%);';
    var content = '';
    if (cfg.type === 'star') content = star(cfg.size, cfg.color);
    if (cfg.type === 'pacman') content = pacman(cfg.size, cfg.color);
    if (cfg.type === 'cassette') content = cassette(cfg.size, cfg.color);
    if (cfg.type === 'diamond') content = diamond(cfg.size, cfg.color);
    if (cfg.type === 'triangle') content = triangle(cfg.size, cfg.color);
    if (cfg.type === 'text') content = wordEl(cfg.text, cfg.color, cfg.size);
    div.innerHTML = content;
    tiltEl.appendChild(div);
    floaterEls.push({ el: div, parX: cfg.parX, parY: cfg.parY, posX: cfg.x, posY: cfg.y });
  });

  // ── Mouse tracking ──────────────────────────────────────────────────────────
  var mx = 0, my = 0, smx = 0, smy = 0;
  var mouseX = 0, mouseY = 0;
  var subjectBlur = 0, subjectBlurTarget = 0;
  var subjectWrap = document.getElementById('subject-wrap');

  window.addEventListener('mousemove', function (e) {
    mx = (e.clientX / innerWidth - 0.5) * 2;
    my = (e.clientY / innerHeight - 0.5) * 2;
    mouseX = e.clientX;
    mouseY = e.clientY;
  });
  window.addEventListener('touchmove', function (e) {
    mx = (e.touches[0].clientX / innerWidth - 0.5) * 2;
    my = (e.touches[0].clientY / innerHeight - 0.5) * 2;
    mouseX = e.touches[0].clientX;
    mouseY = e.touches[0].clientY;
  }, { passive: true });

  function lerp(a, b, t) { return a + (b - a) * t; }

  // ── RAF loop ────────────────────────────────────────────────────────────────
  var rotX = 0, rotY = 0;

  function tick() {
    requestAnimationFrame(tick);

    smx = lerp(smx, mx, CONFIG.PAR_SMOOTH);
    smy = lerp(smy, my, CONFIG.PAR_SMOOTH);

    var tRY = smx * CONFIG.TILT_MAX;
    var tRX = -smy * CONFIG.TILT_MAX;
    rotX = lerp(rotX, tRX, CONFIG.TILT_SMOOTH);
    rotY = lerp(rotY, tRY, CONFIG.TILT_SMOOTH);
    tiltEl.style.transform = 'perspective(900px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg)';

    floaterEls.forEach(function (f) {
      var tx = smx * innerWidth * f.parX;
      var ty = smy * innerHeight * f.parY;
      f.el.style.translate = tx + 'px ' + ty + 'px';

      var elX = (f.posX / 100) * innerWidth + tx;
      var elY = (f.posY / 100) * innerHeight + ty;
      var dx = mouseX - elX, dy = mouseY - elY;
      var dist = Math.sqrt(dx * dx + dy * dy);
      var blurAmount = dist < CONFIG.DOF_FOCUS_RADIUS
        ? 0
        : Math.min(CONFIG.DOF_BLUR_MAX, ((dist - CONFIG.DOF_FOCUS_RADIUS) / 300) * CONFIG.DOF_BLUR_MAX);
      f.el.style.filter = 'blur(' + blurAmount.toFixed(1) + 'px)';
    });

    var centerDist = Math.sqrt(smx * smx + smy * smy) / Math.SQRT2;
    subjectBlurTarget = centerDist * CONFIG.SUBJECT_BLUR_MAX;
    subjectBlur = lerp(subjectBlur, subjectBlurTarget, CONFIG.SUBJECT_BLUR_SMOOTH);
    if (subjectWrap) subjectWrap.style.filter = 'blur(' + subjectBlur.toFixed(2) + 'px)';
  }
  requestAnimationFrame(tick);

  // ── Client-side session check (bypassa la cache lato server) ────────────────
  // Se il cookie synthwave_pass esiste, verifica lato AJAX e rimanda a ?nocache
  document.addEventListener('DOMContentLoaded', function () {
    // Evita loop infiniti se siamo già su ?nocache
    if (location.search.indexOf('nocache') !== -1) {
      return;
    }

    var match = document.cookie.match(/(?:^|;\s*)synthwave_pass=([^;]+)/);
    if (!match) return; // nessun cookie → mostra il form

    // Usa l'URL AJAX localizzato, oppure il fallback hardcoded
    var ajaxUrl = (typeof fabiodipaAjax !== 'undefined' && fabiodipaAjax.url)
      ? fabiodipaAjax.url
      : '/wp-admin/admin-ajax.php';

    var body = new URLSearchParams();
    body.append('action', 'fabiodipa_verify_session');

    fetch(ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.success && data.data && data.data.authenticated) {
          // Sessione valida: redirect anti-cache per far girare PHP autenticato
          location.href = '/?nocache=' + Date.now();
        }
        // Se non valido, rimane sul form (cookie scaduto o eliminato)

      })
      .catch(function () { /* silenzioso */ });
  });

  // ── Loading screen ──────────────────────────────────────────────────────────
  window.addEventListener('load', function () {
    setTimeout(function () {
      var loadEl = document.getElementById('loading');
      if (loadEl) {
        loadEl.classList.add('out');
        document.body.classList.add('sw-loaded');
      }
    }, 200);
  });


  // ── AJAX Login form ─────────────────────────────────────────────────────────
  var landingForm = document.querySelector('.synthwave-landing-form');
  if (landingForm && typeof fabiodipaAjax !== 'undefined') {
    landingForm.addEventListener('submit', function (e) {
      e.preventDefault();
      
      // Sblocca preventivamente l'audio durante l'interazione sincrona esplicita
      // Al altrimenti alcuni browser bloccheranno l'autoplay dopo la risposta AJAX asincrona
      if (typeof window.swUnlockAudioSync === 'function') {
        window.swUnlockAudioSync();
      }

      var input    = landingForm.querySelector('[name="fabiodipa_landing_password"]');
      var btn      = landingForm.querySelector('[type="submit"]');
      var errorEl  = document.querySelector('.synthwave-landing-error');
      var password = input ? input.value : '';

      if (btn) btn.disabled = true;

      var body = new URLSearchParams();
      body.append('action', 'fabiodipa_landing_login');
      body.append('password', password);

      fetch(fabiodipaAjax.url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.success) {
            // Sblocco del gatekeeper (frontend view completo)
            var entranceWrap = document.getElementById('entrance-wrap');
            if (entranceWrap) {
              entranceWrap.style.opacity = '0';
              entranceWrap.style.pointerEvents = 'none';
              setTimeout(function(){ entranceWrap.style.display = 'none'; }, 500);
            }
            
            document.body.classList.add('sw-entered');

            // Trigger avvio musica esplicito:
            if (typeof window.swForceAudioStart === 'function') {
              window.swForceAudioStart();
            }
            
          } else {
            // Show error
            var msg = (data.data && data.data.message) ? data.data.message : 'Password errata, riprova.';
            if (!errorEl) {
              errorEl = document.createElement('div');
              errorEl.className = 'synthwave-landing-error';
              landingForm.parentNode.insertBefore(errorEl, landingForm);
            }
            errorEl.textContent = msg;
            if (btn) btn.disabled = false;
          }
        })
        .catch(function () {
          if (btn) btn.disabled = false;
        });
    });
  }

  // ── Copy to clipboard (Shortcode) ───────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.copy-btn');
    if (!btn) return;
    e.preventDefault();
    var text = btn.getAttribute('data-clipboard-text');
    if (!text) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () {
        var tooltip = bootstrap.Tooltip.getInstance(btn);
        if (!tooltip) {
          tooltip = new bootstrap.Tooltip(btn);
        }
        var tempTitle = btn.getAttribute('title');
        if (tempTitle) {
          btn.setAttribute('data-bs-original-title', tempTitle);
          btn.removeAttribute('title');
        }
        btn.setAttribute('data-bs-original-title', 'Copiato!');
        tooltip.show();
        setTimeout(function () {
          btn.setAttribute('data-bs-original-title', 'Copia');
          tooltip.hide();
        }, 2000);
      });
    }
  });

  // Inizializza tooltips esistenti nella pagina
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });

  // ── Audio Loop + Mute Button ─────────────────────────────────────────────────
  (function () {
    var FADE_DURATION = 3000; // ms per il fade-in iniziale
    var audio = new Audio(THEME_URI + '/assets/mp3/no-fabri-la-promessa.mp3');
    audio.loop = true;
    audio.preload = 'auto';
    audio.volume = 0;

    // Leggi stato mute dalla sessione
    var storedMute = sessionStorage.getItem('sw_audio_muted');
    var userMuted = storedMute === '1';

    // ── Fade-in ─────────────────────────────────────────────────────────────
    var fadeStarted = false;
    var fadeReq = null;

    function fadeIn() {
      // Quando lo chiamiamo forzatamente resettiamo la flag, ma qui preveniamo doppia chiamata
      fadeStarted = true;
      if (fadeReq) { cancelAnimationFrame(fadeReq); }

      if (userMuted) {
        // Mute attivo: porta subito al volume logico pieno ma rimani muted fisicamente
        audio.volume = 1;
        audio.muted = true;
        return;
      }
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / FADE_DURATION, 1);
        audio.volume = progress;
        if (progress < 1) {
          fadeReq = requestAnimationFrame(step);
        }
      }
      fadeReq = requestAnimationFrame(step);
    }

    // ── Avvio audio ─────────────────────────────────────────────────────────
    function startAudio() {
      audio.play().then(function () {
        fadeIn();
      }).catch(function (err) {
        // Autoplay bloccato dal browser (comportamento atteso)
      });
    }

    // Export per il Form di Entrata via AJAX
    window.swUnlockAudioSync = function() {
      // Un banalissimo .play() sincrono sul submit event per far sbloccare il contesto Audio
      audio.volume = 0;
      var p = audio.play();
      if (p !== undefined) {
        p.then(function() { audio.pause(); }).catch(function(){}); // Lo mettiamo in pausa finchè AJAX non ha finito
      }
    };
    
    window.swForceAudioStart = function() {
      hasInteracted = true;
      startAudio();
    };

    // Tenta autoplay 1 sola volta in modo sicuro
    window.addEventListener('load', function () {
      // Fallback: provaci al caricamento solo se stiamo caricando direttamente la pagina sbloccata (autenticata)
      if (document.body.classList.contains('sw-entered')) {
         startAudio();
      }
    });

    var hasInteracted = false;
    var interactionEvents = ['click', 'touchstart', 'keydown'];
    function onFirstInteraction(e) {
      // La musica PUO' partire solo a sito sbloccato
      if (!document.body.classList.contains('sw-entered')) {
        return; 
      }
      
      if (hasInteracted) return;
      hasInteracted = true;
      
      // Se era in pausa (o bloccato) lo sblocchiamo forzatamente ora
      if (audio.paused) {
        startAudio();
      } else {
        // Se per qualche motivo strano stesse già suonando (es. cache), assicura solo il fade
        fadeIn();
      }
    }

    interactionEvents.forEach(function (ev) {
      document.addEventListener(ev, onFirstInteraction, { passive: true, capture: true });
    });

    // ── Pulsante Ingresso (Start) ────────────────────────────────────────────
    var entranceBtn = document.getElementById('entrance-btn');
    if (entranceBtn) {
      entranceBtn.addEventListener('click', function() {
        document.body.classList.add('sw-entered');
      });
    }

    // ── Pulsante Mute ────────────────────────────────────────────────────────
    var muteBtn = document.createElement('button');
    muteBtn.id = 'sw-audio-btn';
    muteBtn.setAttribute('aria-label', 'Mute/Unmute musica');
    muteBtn.innerHTML = userMuted ? '🔇' : '🔊';
    if (userMuted) muteBtn.classList.add('is-muted');
    document.body.appendChild(muteBtn);

    muteBtn.addEventListener('click', function () {
      userMuted = !userMuted;
      audio.muted = userMuted;
      muteBtn.innerHTML = userMuted ? '🔇' : '🔊';
      muteBtn.classList.toggle('is-muted', userMuted);
      sessionStorage.setItem('sw_audio_muted', userMuted ? '1' : '0');
      // Se il volume è ancora a 0 (fade non completato) e si unmuta, avvia il fade
      if (!userMuted && audio.volume === 0 && !audio.paused) {
        fadeStarted = false;
        fadeIn();
      }
    });

    // ── Gestione Cambio Loop Mp3 (Modali) ─────────────────────────────────────
    var currentTrack = 'main';
    var MAIN_TRACK = THEME_URI + '/assets/mp3/no-fabri-la-promessa.mp3';
    var tracks = {
      'modalOne': THEME_URI + '/assets/mp3/loop-modal-1.mp3',
      'modalTwo': THEME_URI + '/assets/mp3/loop-modal-2.mp3',
      'modalThree': THEME_URI + '/assets/mp3/loop-modal-3.mp3'
    };

    function switchTrackTo(newSrc) {
      if (audio.src.indexOf(newSrc) !== -1) return; // eviti glitch se è già la traccia corretta
      var wasPlaying = !audio.paused;
      audio.pause();
      audio.src = newSrc;
      audio.currentTime = 0;
      
      // Resetta il volume a 0 per forzare un nuovo fade-in in ogni cambio
      audio.volume = 0;
      fadeStarted = false;

      if (wasPlaying) {
        audio.play().then(function() {
          fadeIn();
        }).catch(function(){}); // In caso il browser blocchi (raro se c'è stata interazione)
      }
    }

    Object.keys(tracks).forEach(function(modalId) {
      var modalEl = document.getElementById(modalId);
      if (modalEl) {
        modalEl.addEventListener('show.bs.modal', function() {
           switchTrackTo(tracks[modalId]);
        });
      }
    });

    // Al reset/chiusura di *qualsiasi* modale
    var allModals = document.querySelectorAll('.modal');
    allModals.forEach(function(modalEl) {
      modalEl.addEventListener('hidden.bs.modal', function() {
        // Se c'è ancora un'altra modale aperta non fare nulla (es. modali sovrapposte)
        if (!document.body.classList.contains('modal-open')) {
          switchTrackTo(MAIN_TRACK);
        }
      });
    });

  }());

}());
